<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <circle cx="12" cy="12" r="11.5" stroke="#000"/>
  <path fill="#000" d="M11.25 9.5h1.5V17h-1.5V9.5zM11.25 7h1.5v1.5h-1.5V7z"/>
</svg>
